import React, {useEffect, useState} from 'react'
//---REDUX
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import allTheActions from '../actions'
//---
import Navbar from "../components/navbar"
import Menu from "../components/menu"
import TitleH1 from "../components/titleH1"
import Swal from "sweetalert2"
import Table from "../components/table";
import Image from "../components/image";
import edit from "../assets/edit.png"
import deleteImg from "../assets/delete.png"
import FormUser from "../components/formUser"
import DivWhite from "../components/divWhite";

const CreateUser = props => {
    const [clubs, setClubs] = useState([])
    const [licences, setLicences] = useState([])
    const [data, setData] = useState({})
    const [update, setUpdate] = useState(false)
    const [licenceSolo, setSolo] = useState(false)
    const [users, setUsers] = useState([])
    const [title, setTitle] = useState("Création d'un nouvel utilisateur")

    useEffect(() => {
        const fetchClubs = async () => {
            const res = await props.actions.club.getAllClubs()
            await setLicences(await props.actions.licence.getAllLicences())
            await setUsers(await props.actions.user.findAllUsers())
            setClubs(res.clubs)
        }
        fetchClubs()
    }, [props.actions])

    const handleChange = async event => {
        setData(await {...data, [event.target.name]: event.target.value})
    }

    const handleChangeClub = async event => {
        setSolo(event.target.value === "none")
        if (event.target.value !== "none") setData(await {
            ...data,
            licenceSolo: "none",
            [event.target.name]: event.target.value
        })
        else setData(await {...data, [event.target.name]: event.target.value})
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        //On différencie l'update et la création
        if (update) {
            if (await props.actions.user.updateOneUser(data))
                Swal.fire(
                    'Bravo !',
                    `Mise à jour des informations de ${data.prenom} ${data.nom} réussie !`,
                    'success'
                ).then(async () => setUsers(await props.actions.user.findAllUsers()))
        } else if (await props.actions.user.create(data))
            Swal.fire(
                'Bravo !',
                'Création de l\'utilisateur réussie !',
                'success'
            ).then(async () => setUsers(await props.actions.user.findAllUsers()))
    }

    const handleClickEdit = async (idUser, mail, prenom, nom, idClub, admin, licenceSolo, numeroLicence) => {
        setData({
            idUser: idUser,
            admin: admin,
            idClub: idClub,
            licenceSolo: licenceSolo,
            mail: mail,
            nom: nom,
            prenom: prenom,
        })
        if (licenceSolo === "true") setData({...data, numeroLicence: numeroLicence})
        setTitle(`Modifier ${prenom} ${nom}`)
        setUpdate(true)
        window.scrollTo(0, 0)
    }

    const deleteUser = async (idUser, prenom, nom) => {
        if (window.confirm(`Vous êtes sur le point de supprimer le compte ${prenom} ${nom}. Continuer ?`))
            if (await props.actions.user.deleteOneUser(idUser))
                Swal.fire(
                    'Tout est bon !',
                    'Supression du compte réussie',
                    'success'
                ).then(async () => setUsers(await props.actions.user.findAllUsers()))
    }

    const resetForm = () => {
        setTitle("Création d'un nouvel utilisateur")
        setData({})
        setUpdate(false)
    }

    return (
        <>
            <Navbar/>
            <Menu/>
            <TitleH1 content={title} id="titre"/>
            <FormUser clubs={clubs} data={data} handleChange={handleChange} handleChangeClub={handleChangeClub}
                      handleSubmit={handleSubmit} licences={licences} licenceSolo={licenceSolo} setData={setData}
                      resetForm={resetForm}/>
            <br/>
            <br/>
            <hr/>
            <br/>
            <TitleH1 content="Tous les utilisateurs"/>
            {users.length > 0 ?
                <DivWhite content={
                    <Table content={
                        <>

                            <thead>
                            <tr>
                                <td>Prénom</td>
                                <td>Nom</td>
                                <td>Adresse mail</td>
                                <td>Club</td>
                                <td colSpan="2">Actions</td>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                users.length > 0 && clubs.length > 0 ?
                                    users.map(user => {
                                        const club = clubs.filter(data => data._id === user.idClub)
                                        return (
                                            <tr key={user._id}>
                                                <td>{user.prenom}</td>
                                                <td>{user.nom}</td>
                                                <td>{user.mail}</td>
                                                <td>{club[0] && club[0].nom}</td>
                                                <td><Image src={edit} width="25" height="25" cursor="pointer"
                                                           onClick={() => handleClickEdit(user._id, user.mail, user.prenom, user.nom, user.idClub, user.admin, user.licenceSolo, user.numeroLicence)}/>
                                                </td>
                                                <td><Image src={deleteImg} width="25" height="25"
                                                           onClick={() => deleteUser(user._id, user.prenom, user.nom)}
                                                           cursor="pointer"/></td>
                                            </tr>
                                        )
                                    })
                                    : null}
                            </tbody>
                        </>
                    } width="100%" cursor="unset"/>
                } width="100%"/>

                : null}
        </>
    )
}

const mapStateToProps = state => ({
    licenceState: state.licence,
    clubState: state.club,
    userState: state.user
})

const mapDispatchToProps = () => dispatch => ({
    actions: {
        licence: bindActionCreators(allTheActions.licence, dispatch),
        club: bindActionCreators(allTheActions.club, dispatch),
        user: bindActionCreators(allTheActions.user, dispatch)
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateUser)
